import { createFileRoute } from '@tanstack/react-router';

// relative imports
import OrgInviteRequiredPage from '../../components/shared/authentication/OrgInviteRequiredPage';

type OrgInviteRequiredSearch = {
  orgName?: string;
};

export const Route = createFileRoute('/_public/org-invite-required')({
  validateSearch: (
    search: Record<string, unknown>,
  ): OrgInviteRequiredSearch => ({
    orgName: search.orgName as string,
  }),
  component: OrgInviteRequiredPage,
  staticData: {
    accountOptional: true,
    hideHeader: true,
    meta: {
      title: 'Invitation Required | Ledgible',
    },
  },
});
